import {
  Chip,
  Box,
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
} from '@mui/material';
import { styles } from './styles';
import PersonIcon from '@mui/icons-material/Person';
import { purple, green } from '@mui/material/colors';

const MultiSelectChip = (props) => {
  const { user, item, handleChange } = props;

  const getStyles = (name, val) => {
    return {
      fontWeight: user[name].indexOf(val) === -1 ? 400 : 600,
    };
  };
  return (
    <FormControl fullWidth size="small" sx={styles.select} required>
      <Select
        name={item.name}
        id={`multi-select-${item.name}`}
        input={<OutlinedInput />}
        value={user[item.name] || ''}
        onChange={handleChange}
        renderValue={(selected) => {
          const valuesToRender = Array.isArray(selected) ? selected : (selected ? [selected] : []);
          return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {valuesToRender.map((value) => {
              let color;
              if (item.name === 'role') {
                // value is 'admin', 'developer', or 'user'
                color = value === 'admin' ? 'error' : 'info'; // Use lowercase for condition
                const displayLabel = value.charAt(0).toUpperCase() + value.slice(1); // Capitalize for display
                return (
                  <Chip
                    key={value}
                    label={displayLabel} // Display capitalized label
                    color={color}
                    icon={<PersonIcon />}
                    sx={{ textTransform: 'capitalize' }} // This also helps, but explicit label is safer
                  />
                );
              } else {
                color = value === 'Dev' || value === 'developer' ? purple[100] : green[100];
                const label = value === 'Dev' ? 'Development' : 'Production';
                return (
                  <Chip
                    key={value}
                    label={label}
                    sx={{ backgroundColor: color, textTransform: 'capitalize' }}
                  />
                );
              }
              })}
            </Box>
          );
        }}
      >
        {item.list.map((li) => {
          // li is 'Admin', 'Developer', 'User'
          const menuItemValue = typeof li === 'string' ? li.toLowerCase() : li;
          return (
            <MenuItem key={li} value={menuItemValue} style={getStyles(item.name, li)}>
              {li} {/* Display capitalized version */}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default MultiSelectChip;
